// extracted by mini-css-extract-plugin
export var input = "TextInput-module--input--dRuVO";
export var textarea = "TextInput-module--textarea--1EGmA";